<template>
  <b-modal
    :visible="visible"
    hide-footer
    button-size="sm"
    size="lg"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="customer-list-modal"
  >
    <template v-slot:modal-title>Lista de clientes</template>
    <section class="container-fluid">
      <CRow>
        <CCol md="12">
          <CCard>
            <CCardHeader>
              <slot name="header">
                <CIcon size="sm" name="cil-building" />Clientes
                <div class="card-header-actions">
                  <button
                    @click="customerAddMod"
                    class="btn btn-success btn-sm"
                    type="button"
                  >
                    <CIcon size="sm" name="cib-Addthis" />
                  </button>
                </div>
              </slot>
            </CCardHeader>
            <CCardBody>
              <CDataTable
                class="table-bordered c-table c-table-main"
                :hover="true"
                :striped="true"
                :bordered="true"
                :small="true"
                :items="items"
                :fields="fields"
                :sorter="{ external: true, resetable: true }"
                @update:sorter-value="filterTable"
                :columnFilter="{ external: true, lazy: true }"
                @update:column-filter-value="filterTable"
                :column-filter-value.sync="columnFilter"
                :loading="loading"
              >
                <template #no-items-view>
                  <div class="no-items-view">
                    {{
                      loading
                        ? "Cargando datos..."
                        : "No existen clientes registrados"
                    }}
                    <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                  </div>
                </template>
                <!-- filters -->
                <template #enabled-filter>
                  <b-form-select
                    v-model="columnFilter.enabled"
                    :options="enabledOptions"
                    value-field="code"
                    text-field="label"
                    id="enabled"
                    size="sm"
                    @change="filterTable"
                  >
                  </b-form-select>
                </template>
                <template #detail-filter>
                  <b-button
                    @click="reload"
                    variant="secondary"
                    size="sm"
                    title="Recargar tabla"
                  >
                    <CIcon size="sm" name="cil-reload" />
                  </b-button>
                  <b-button
                    @click="clean"
                    variant="secondary"
                    size="sm"
                    title="Limpiar filtros"
                  >
                    <CIcon size="sm" name="cil-filter-x" />
                  </b-button>
                </template>
                <!-- data -->
                <template #id="{ index }">
                  <td>{{ (page - 1) * limit + (index + 1) }}</td>
                </template>
                <template #content="{ item }">
                  <td>
                    {{
                      item.content != null && item.content != ""
                        ? item.content
                        : ""
                    }}
                  </td>
                </template>
                <template #enabled="{ item }">
                  <td>
                    <CBadge color="success" v-if="item.enabled == true"
                      >Activo</CBadge
                    >
                    <CBadge color="danger" v-else>Inactivo</CBadge>
                  </td>
                </template>

                <template #detail="{ item }">
                  <td>
                    <b-button-group size="xs">
                      <b-button
                        v-if="item.enabled == true"
                        @click="selectCustomer(item)"
                        variant="primary"
                        size="sm"
                        title="Seleccionar"
                      >
                        Seleccionar
                      </b-button>
                      <b-button
                        @click="modalEdit(item.id)"
                        variant="warning"
                        size="sm"
                        title="Editar"
                      >
                        <CIcon size="sm" name="cil-pencil" />
                      </b-button>
                      <b-button
                        @click="modalDelete(item.id)"
                        variant="danger"
                        title="Eliminar"
                      >
                        <CIcon size="sm" name="cil-trash" />
                      </b-button>
                    </b-button-group>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
            <div>
              <CPagination
                :activePage.sync="page"
                :pages="pages"
                size="sm"
                align="center"
                @update:activePage="updateTable"
              />
              <TableRecords
                :total="total"
                :loading="loading"
                :from="from"
                :to="to"
                :page="page"
              />
            </div>
          </CCard>
        </CCol>
      </CRow>
      <!-- Modal de eliminar customer -->
      <section v-if="modShowDelCustomer">
        <CustomerDeleteModal
          :customer_id="customer_id"
          :modShowDelCustomer="modShowDelCustomer"
          @customerDeleteModal="afterDeleteCustomer"
        ></CustomerDeleteModal>
      </section>
      <!-- Modal de editar customer -->
      <section v-if="modShowCustomerEdit">
        <CustomerEditModal
          :customer_id="customer_id"
          :modShowCustomerEdit="modShowCustomerEdit"
          @customerEditModal="afterEditCustomer"
        ></CustomerEditModal>
      </section>
      <!-- Modal para anadir customer -->
      <section v-if="modShowCustomerAdd">
        <CustomerAddModal
          :modShowCustomerAdd="modShowCustomerAdd"
          @customerAddModal="afterAddCustomer"
        >
        </CustomerAddModal>
      </section>
    </section>
  </b-modal>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import Constants from "@/plugins/constants";
// services
import Customers from "@/plugins/services/customers";
// components
import CustomerAddModal from "@/entities/customers/CustomerAddModal";
import CustomerDeleteModal from "@/entities/customers/CustomerDeleteModal";
import CustomerEditModal from "@/entities/customers/CustomerEditModal";

export default {
  name: "CustomerListModal",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    CustomerDeleteModal,
    CustomerAddModal,
    CustomerEditModal,
    TableRecords,
  },
  props: {
    modShowCustomerList: { type: Boolean, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width:8px;",
        },
        {
          key: "nit_name",
          label: "Nombre / Razón social",
          _style: "width:35%;",
        },
        {
          key: "nit_document",
          label: "Documento / NIT",
          _style: "width:35%;",
        },
        {
          key: "enabled",
          label: "Estado",
          filter: true,
          _style: "width:110px;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      items: [],
      columnFilter: { column: null, asc: false, enabled: true },
      enabledOptions: Constants.enabledOptions,
      page: 0,
      pages: 0,
      limit: 10,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      customer_id: 0,
      modShowDelCustomer: false,
      modShowCustomerEdit: false,
      modShowCustomerAdd: false,
      dataEmit: { modalShow: false, data: null },
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowCustomerList;
    },
  },
  mounted() {
    this.getAll(this.columnFilter);
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Customers.all(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = { column: null, asc: false, enabled: true };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    modalDelete(id) {
      this.modShowDelCustomer = true;
      this.customer_id = id;
    },
    afterDeleteCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowDelCustomer = response.modalShow;
    },
    modalEdit(id) {
      this.modShowCustomerEdit = true;
      this.customer_id = id;
    },
    afterEditCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowCustomerEdit = response.modalShow;
    },
    customerAddMod() {
      this.modShowCustomerAdd = true;
    },
    afterAddCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.reload();
      }
      this.modShowCustomerAdd = response.modalShow;
    },
    closeModal(data = null) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.$emit("customerListModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
    selectCustomer(customer) {
      this.closeModal(customer);
    },
  },
};
</script>
